module.exports = __webpack_public_path__ + "img/price.00ea88a7.svg";